import { useOrgIntegrations } from "@/api/integrations";
import { useMemo } from "react";

/** Resolves the org's Granola integration connection (one per org). */
export function useGranolaConnection() {
  const { data: integrations, isLoading } = useOrgIntegrations();

  const result = useMemo(() => {
    if (!integrations) {
      return { connectionId: undefined, isLoading: true, hasConnection: false };
    }
    const conn = integrations.find(
      (i) => i.platform === "granola" && i.connected,
    );
    return {
      connectionId: conn?.integration_connection_id,
      isLoading: false,
      hasConnection: !!conn,
    };
  }, [integrations]);

  return { ...result, isLoading: isLoading || result.isLoading };
}
